'use client';

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ThemeContext from './_themeContext';

interface Props {
  children: React.ReactNode;
}

export default function ThemeProvider({ children }: Props) {
  const [theme, setTheme] = useState<'light' | 'dark'>('light');
  const themeConfig = useMemo(() => ({ theme }), [theme]);

  const onScroll = useCallback(() => {
    const isDark = theme === 'dark';
    const { scrollY } = window;

    if ((isDark && !scrollY) || (!isDark && scrollY)) {
      setTheme(scrollY > 50 ? 'dark' : 'light');
    }
  }, [theme]);

  useEffect(() => {
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  return <ThemeContext.Provider value={themeConfig}>{children}</ThemeContext.Provider>;
}
